import { useState } from "react";

import ShareModal from "../channels/modals/ShareModal";
import BottomSheetModalHOC from "@qoohoo/common/library/modals/BottomSheetModalHOC";

import useSessionStore from "../../store/sessionStore";
import Modal from "@qoohoo/common/library/modals/Modal";
import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, pageview } from "@qoohoo/common/constants/analytics";
import {
  facebookIcon,
  instagramIcon,
  twitterIcon,
  websiteIcon,
  youtubeIcon,
} from "../../constants/assets";

export default function ProfileFooter({ profileDetails }) {
  const currentUser = useSessionStore((state) => state.userData);
  const [shareModalOpen, setshareModalOpen] = useState(false);

  const hasSocialInfo = profileDetails?.user_social_info?.length > 0;

  function openShareModal() {
    setshareModalOpen(true);
  }

  function closeShareModal() {
    setshareModalOpen(false);
  }

  function getSocialIcon(platformName) {
    let icon = null;

    if (platformName === "twitter") {
      icon = twitterIcon;
    } else if (platformName === "instagram" || platformName === "ig") {
      icon = instagramIcon;
    } else if (platformName === "facebook" || platformName === "fb") {
      icon = facebookIcon;
    } else if (platformName === "youtube" || platformName === "yt") {
      icon = youtubeIcon;
    }

    return icon;
  }

  function getSocialLink(social) {
    let socialLink = null;

    if (social && social.platform) {
      const platformName = social.platform.toLowerCase();
      const platformUrl = social.platform_profile_url;
      const platformIcon = getSocialIcon(platformName);

      if (platformIcon && platformUrl) {
        socialLink = (
          <a key={platformName} href={platformUrl} target="_blank">
            <img className="w-5 h-5" src={platformIcon} alt={platformName} />
          </a>
        );
      }
    }

    return socialLink;
  }

  function getValidUrl(url) {
    const pattern = /^(https?:\/\/)/;
    const isValid = pattern.test(url);
    let validUrl = url;

    if (!isValid) {
      validUrl = `https://${url}`;
    }

    return validUrl;
  }

  return (
    <>
      <section className="flex flex-col lg:flex-row justify-center lg:justify-between items-center mt-[70px] lg:mt-[72px] py-5 px-0 lg:px-10 bg-gradient-to-br from-[#1F2429] to-[#1D2225] rounded-b-3xl">
        <button
          onClick={() => {
            Track.buttonClick(button.support_my_passion, {
              current_screen: pageview.profile,
              ...profileDetails,
            });
            openShareModal();
          }}
          className="flex justify-center items-center py-4 px-6 rounded-full text-sm lg:text-base leading-[21px] lg:leading-6 font-medium font-inter support-my-passion-btn-bg outline-none focus:outline-none hover:opacity-90"
        >
          Support my passion
          <img
            src="/assets/social-icons/peace.svg"
            alt="peace icon"
            className="w-5 h-5 ml-2"
          />
        </button>
        <div className="flex items-center space-x-4 mt-6 lg:mt-0">
          {hasSocialInfo &&
            profileDetails.user_social_info.map((social) =>
              getSocialLink(social)
            )}
          {profileDetails?.website_url && (
            <a href={getValidUrl(profileDetails.website_url)} target="_blank">
              <img className="w-5 h-5" src={websiteIcon} alt="website" />
            </a>
          )}
        </div>
      </section>
      <Modal isOpen={shareModalOpen} closeModal={closeShareModal}>
        <BottomSheetModalHOC>
          <ShareModal
            profileDetails={profileDetails}
            closeModal={closeShareModal}
            currentUsername={currentUser?.username}
          />
        </BottomSheetModalHOC>
      </Modal>
    </>
  );
}
